// Components==============
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Modal from '../Modal';
import RichText from '../RichText';
import './index.module.scss';
// =========================

const framerButton = {
    hover: {
        x: 5,
    },
    tap: {
        x: 0,
    },
};

const ConditionalLink = ({ to, children }) => {
    if (to.includes('http'))
        return (
            <a href={to} styleName="wrapper" target="_blank" rel="noreferrer">
                {children}
            </a>
        );

    return (
        <NavLink to={to} styleName="wrapper">
            {children}
        </NavLink>
    );
};

const Link = ({ text, to, subtitle }) => (
    <motion.div variants={framerButton} whileHover="hover" whileTap="tap">
        <ConditionalLink to={to}>
            <div styleName="text">
                <span>{text}</span>
                <p>{subtitle}</p>
            </div>
            <div styleName="circle">
                <FontAwesomeIcon icon={faArrowRight} />
            </div>
        </ConditionalLink>
    </motion.div>
);

// const Popup = ({ popup, text, popupAccent, subtitle }) => {
//     const [modalIsOpen, setModalIsOpen] = useState(false);

//     return (
//         <>
//             <motion.button
//                 styleName="wrapper"
//                 type="button"
//                 variants={framerButton}
//                 whileHover="hover"
//                 whileTap="tap"
//                 onClick={() => setModalIsOpen(true)}
//             >
//                 <div styleName="text">
//                     <span>{text}</span>
//                     <p>{subtitle}</p>
//                 </div>
//                 <div styleName="circle">
//                     <FontAwesomeIcon icon={faArrowRight} />
//                 </div>
//             </motion.button>
//             <AnimatePresence>
//                 {modalIsOpen && (
//                     <Modal
//                         color={popupAccent}
//                         closeModal={() => setModalIsOpen(false)}
//                     >
//                         <div styleName="popup-wrapper">
//                             <RichText accent={popupAccent} richText={popup} />
//                         </div>
//                     </Modal>
//                 )}
//             </AnimatePresence>
//         </>
//     );
// };

const File = ({ file, text, subtitle }) => (
    <motion.a
        href={`/storage/${file}`}
        download
        styleName="wrapper"
        type="button"
        variants={framerButton}
        whileHover="hover"
        whileTap="tap"
    >
        <div styleName="text">
            <span>{text}</span>
            <p>{subtitle}</p>
        </div>
        <div styleName="circle">
            <FontAwesomeIcon icon={faArrowRight} />
        </div>
    </motion.a>
);

export default function ArrowButton({
    text,
    type,
    to,
    file,
    // popup,
    // popupAccent,
    subtitle,
}) {
    // if (type === 'popup')
    //     return (
    //         <Popup
    //             popup={popup}
    //             text={text}
    //             popupAccent={popupAccent}
    //             subtitle={subtitle}
    //         />
    //     );

    if (type === 'file')
        return <File file={file} text={text} subtitle={subtitle} />;

    return <Link to={to} text={text} subtitle={subtitle} />;
}
